module.exports = __webpack_public_path__ + "static/media/Dashboard.54941470.svg";